module.exports = {
  host: process.env.HOST || 'localhost',
  open: true,
  port: process.env.PORT || 8081,
  apiRoot: process.env.VUE_APP_API_ROOT || 'http://localhost:8001',
  project: {
    titleLogo: true,
    logoSize: 'normal', // 'wide'
    subtitle: '',
    menuSubtitle: '',
    footerTitle: 'Archivio Chimera &copy; 2026',
    footerText: `<div class="grid grid-cols-2 w-full md:w-4/5 lg:w-3/4 xl:w-1/2 m-auto gap-10 py-10">
      <div class="col-span-1 footer-1 text-xs/6">
        <div class="text-left">
          Content license: CC BY-SA 4.0 International<br/>
          Metadata license: CC0 1.0 Universal
        </div>
      </div>
      <div class="col-span-1 footer-2 text-left text-xs/6">
        <div class="text-left">
          Realizzazione Web a cura di:<br/>
          LiEC - Laboratorio interdisciplinare sulle Eredità Culturali<br/>
          Dipartimento SAGAS, Università degli Studi di Firenze
        </div>
      </div>
    </div>`,
    copyright: 'LiEC @ 2026',
    subtitleSize: 'sm',
    font: {
      title: 'font-titillium',
      body: 'font-titillium'
    },
    style: {
      background: 'bg-white',
      homeText: 'text-white',
      text: 'text-black',
      color: '#000'
    },
    bars: {
      top: { position: 'top', cols: 8, logoSize: 4, logoLink: '/', logoAlt: 'Logo Top', menuSize: 4, hideOnMobile: true},
      main: { position: 'main', cols: 8, logoSize: 2, logoLink: '/', logoAlt: process.env.VUE_APP_NAME, menuSize: 6}
    },
  },
  search: {
    models: [
      {value: 'cards', label: 'Schede'},
      {value: 'persons', label: 'Persone'},
      {value: 'card_containers', label: 'Contenitori Schede'},
      {value: 'chimera_cards', extends: 'cards', label: 'Campi scheda Chimera'},
      {value: 'places', extends: 'cards', label: 'Campi Luogo'},
    ],
    fields: [
      {field: 'tags', type: 'select-api', label: 'Tags', vocabulary: 'tags'}
    ]
  },
  templates: {
    persons: ['tags', 'map', 'gallery', 'start_fields', 'related_entities', 'end_fields', 'references'],
    places: ['tags', 'map', 'gallery', 'start_fields', 'related_entities', 'end_fields'],
    chimera_cards: ['tags', 'map', 'gallery', 'persons', 'card_containers', 'cardable_start_fields', 'related_entities', 'cardable_end_fields', 'relateds'],
    scan_cards: ['tags', 'map', 'gallery', 'persons', 'card_containers', 'cardable_start_fields', 'related_entities', 'cardable_end_fields', 'references', 'relateds'],
    f_cards: ['tags', 'gallery', 'collection', 'persons', 'map', 'card_containers', 'cardable_start_fields', 'related_entities', 'cardable_end_fields', 'references', 'relateds'],
    itinerary: ['description', 'map', 'timeline_vertical'],
    'landscape-itinerary': ['description', 'timeline_horizontal'],
    'temporary-exhibition' : ['description', 'cards'],
    exhibition: ['description', 'cards'],
    'art-collection': ['description', 'cards'],
    glossary: ['description', 'cards'],
    collections: ['tags', 'description', 'gallery', 'f_cards'],
    references: ['tags', 'fields', 'cards', 'persons']
  },
  models: {
    persons: { 
      single: 'Persona', 
      plural: 'Persone', 
      visibility: 'all', 
      color: 'blue',
      fields: [
        {field: 'name', type: 'text', label: 'Nome scelto', position: 'start', visibility: 'all'},
        {field: 'pre_name', type: 'text', label: 'Prenome', position: 'start', visibility: 'all'},
        {field: 'first_name', type: 'repeating', label: 'Primo nome', position: 'start', visibility: 'all'},
        {field: 'middle_name', type: 'text', label: 'Secondo nome', position: 'start', visibility: 'all'},
        {field: 'last_name', type: 'repeating', label: 'Cognome', position: 'start', visibility: 'all'},
        {field: 'title', type: 'text', label: 'Titolo', position: 'start', visibility: 'all'},
        {field: 'nick_name', type: 'repeating', label: 'Soprannome', position: 'start', visibility: 'all'},
        {field: 'initials', type: 'text', label: 'Iniziali', position: 'start', visibility: 'profile'},
        {field: 'sex', type: 'text', label: 'Sesso', position: 'start', visibility: 'all'},
        {field: 'birth_date', type: 'text', label: 'Data di nascita', position: 'start', visibility: 'all'},
        {field: 'birth_place', type: 'text', label: 'Luogo di nascita', position: 'start', visibility: 'all'},
        {field: 'death_date', type: 'text', label: 'Data del decesso', position: 'start', visibility: 'all'},
        {field: 'death_place', type: 'text', label: 'Luogo del decesso', position: 'start', visibility: 'all'},
        {field: 'from_date', type: 'text', label: 'Data nascita testuale', position: 'start', visibility: 'all'},
        {field: 'to_date', type: 'text', label: 'Data del decesso estuale', position: 'start', visibility: 'all'},
        {field: 'notes', type: 'text', label: 'Note', position:'start', visibility: 'profile'},
        {field: 'origin', type: 'text', label: 'Origine', position:'start', visibility: 'profile'},
        {field: 'nationality', type: 'text', label: 'Nazionalità', position: 'start', visibility: 'all'},
        {field: 'website', type: 'text', label: 'Link sito web', position: 'start', visibility: 'all'},
        {field: 'biography', type: 'text', label: 'Biografia', position: 'end', visibility: 'all'},
      ],
      pivot: {
        locations: [
          {field: 'location_person_type_id', type: 'text', label: 'Tipo di luogo', position: 'start', visibility: 'all'},
          {field: 'description', type: 'text', label: 'Descrizione', position: 'start', visibility: 'all'},
        ],
        cards: [
          {field: 'card_person_type_id', type: 'text', label: 'Tipo di scheda', position: 'start', visibility: 'all'},
          {field: 'description', type: 'text', label: 'Descrizione', position: 'start', visibility: 'all'},
        ],
        related: ['cards']
      }
    },
    card_containers: {
      single: 'Itinerario',
      plural: 'Itinerari',
      visibility: 'all',
      color: 'yellow',
      fields: [
        {field: 'name',         type: 'text', label: 'Nome'},
        {field: 'description',  type: 'text', label: 'Descrizione'},
        {field: 'code',         type: 'text', label: 'Codice'},
        {field: 'card_container_type_id', type: 'text', label: 'Tipologia', position: 'start', visibility: 'all'},
      ],
      pivot: {
        cards: [
          {field: 'start_date', type: 'date', label: 'Data inizio', position: 'start', visibility: 'all'},
          {field: 'end_date', type: 'date', label: 'Data fine', position: 'start', visibility: 'all'},
          {field: 'description', type: 'text', label: 'Descrizione', position: 'start', visibility: 'all'},
        ]
      },
    },
    references: {
      single: 'Riferimento bibliografico',
      plural: 'Riferimenti bibliografici',
      visibility: 'all',
      color: 'purple',
      fields: [
        {field: 'title', type: 'text', label: 'Titolo', position: 'start', separator: ', '},
        {field: 'author', type: 'text', label: 'Autore', position: 'start', visibility: 'all', separator: ', '},
        {field: 'year', type: 'text', label: 'Anno', position: 'start', visibility: 'all', separator: ' '},
        {field: 'citation', type: 'text', label: 'Citazione', format: 'normal', separator: ''},
      ],
      pivot: {
        cards: [
          {field: 'citation', type: 'text', label: 'Citazione', position: 'start', visibility: 'all'}
        ]
      },
    },
    cards: {
      single: 'Scheda',
      plural: 'Schede',
      visibility: 'all',
      color: 'green',
      fields: [
        {field: 'name', type: 'text', label: 'Nome'},
        {field: 'description', type: 'text', label: 'Descrizione'},
        {field: 'code', type: 'text', label: 'Codice'},
        {field: 'regione', type: 'select-api', label: 'Regione', vocabulary: 'regions'},
        {field: 'provincia', type: 'select-api', label: 'Provincia', vocabulary: 'provinces'},
      ],
      pivot: {
        persons: [
          {field: 'card_person_type_id', type: 'text', label: 'Tipo di scheda', position: 'start', visibility: 'all'},
          {field: 'description', type: 'text', label: 'Descrizione', position: 'start', visibility: 'all'},
        ],
        cards: [
          {field: 'description', type: 'text', label: 'Note sulle relazioni (REZ)', position: 'start', visibility: 'all'},
          {field: 'direction', type: 'text', label: 'Specifiche tipo relazione (RSES)', position: 'start', visibility: 'all'},
          {field: 'type', type: 'vocabulary', label: 'Tipo di relazione (RSER)', position: 'start', visibility: 'all'},
          {field: 'notes', type: 'text', label: 'Altre note', position: 'start', visibility: 'all'},
        ]
      }
    },
    collections: {
      single: 'Collezione',
      plural: 'Collezioni',
      visibility: 'all',
      color: 'yellow',
      fields: [
        {field: 'name', type: 'text', label: 'Nome', position: 'start', visibility: 'all'},
        {field: 'bibliography', type: 'text', label: 'Bibliografia', position: 'start', visibility: 'all'},
      ],
      pivot: {
        f_cards: [
          {field: 'name', type: 'text', label: 'Nome', position: 'start', visibility: 'all'},
        ]
      },
      related: ['f_cards']
    },
    pages: { 
      single: 'Pagina', 
      plural: 'Pagine', 
      visibility: 'all', 
      color: 'red',
      fields: [
        {field: 'title', type: 'text', label: 'Titolo', position: 'start', visibility: 'all'},
      ]
    },
    chimera_cards: { 
      extended: true, 
      single: 'Scheda Chimera', 
      plural: 'Schede Chimera',
      visibility: 'all',
      fields: [
        {field: 'data_ripresa', type: 'text', label: 'Data ripresa', position: 'start', visibility: 'all'},
        {field: 'autore_ripresa', type: 'text', label: 'Autore ripresa', position: 'start', visibility: 'all'},
        {field: 'supporto', type: 'text', label: 'Supporto', position: 'start', visibility: 'all'},
        {field: 'digitalizzato', type: 'text', label: 'Digitalizzato', position: 'start', visibility: 'all'},
        {field: 'tipo_video', type: 'text', label: 'Tipo video', position: 'start', visibility: 'all'},
        {field: 'cassetta_video', type: 'text', label: 'Cassetta video', position: 'start', visibility: 'all'},
        {field: 'id_maf', type: 'text', label: 'ID MAF', position: 'start', visibility: 'all'},
        {field: 'faldone_maf', type: 'text', label: 'Faldone MAF', position: 'start', visibility: 'all'},
        {field: 'id_cdr', type: 'text', label: 'ID CDR', position: 'start', visibility: 'all'},
        {field: 'scheda_cdr', type: 'text', label: 'Scheda CDR', position: 'start', visibility: 'all'},
        {field: 'descrizione', type: 'text', label: 'Descrizione', position: 'start', visibility: 'all'},
        {field: 'regione', type: 'text', label: 'Regione', position: 'start', visibility: 'all'},
        {field: 'provincia', type: 'text', label: 'Provincia', position: 'start', visibility: 'all'},
        {field: 'comune', type: 'text', label: 'Comune', position: 'start', visibility: 'all'},
        {field: 'localita', type: 'text', label: 'Località', position: 'start', visibility: 'all'},
        {field: 'scavo_contesto', type: 'text', label: 'Scavo contesto', position: 'start', visibility: 'all'},
        {field: 'estero', type: 'text', label: 'Estero', position: 'start', visibility: 'all'},
        {field: 'id_inventario', type: 'text', label: 'ID inventario', position: 'start', visibility: 'all'},
        {field: 'note', type: 'text', label: 'Note', position: 'start', visibility: 'all'},
        {field: 'sabap_type', type: 'text', label: 'Tipologia', position: 'start', visibility: 'all'},
        {field: 'sabap_container', type: 'text', label: 'Fondo', position: 'start', visibility: 'all'},
        {field: 'sabap_format', type: 'text', label: 'Formato', position: 'start', visibility: 'all'},
        {field: 'sabap_preservation', type: 'text', label: 'Ambito di tutela', position: 'start', visibility: 'all'},
        {field: 'sabap_inventory', type: 'text', label: 'Inventario', position: 'start', visibility: 'all'},
        {field: 'sabap_institute', type: 'text', label: 'Ente', position: 'start', visibility: 'all'},
        {field: 'sabap_historical', type: 'text', label: 'Periodo storico', position: 'start', visibility: 'all'},
        {field: 'date', type: 'text', label: 'Data', position: 'start', visibility: 'all'},
      ],
      related: []
    },
    places: {
      model: 'Luogo',
      parent: 'Luogo',
      fields: [
        {field: 'latin_transcript', label: 'Trascrizione latina', type: 'text', related: 'cardable'},
        {field: 'literal_transcript', label: 'Trascrizione letterale', type: 'text', related: 'cardable'},
        {field: 'region', label: 'Regione', type: 'text', related: 'cardable'},
        // ReferenceSources fields
        {field: 'reference_sources', label: 'Fonti', type: 'relateds', title: 'name'},
        // References fields
        {field: 'references', label: 'Bibliografia', type: 'relateds', title: 'citation'},
        // Place fields
        {field: 'parents', label: 'Toponimo', type: 'relateds', title: 'name', classes: 'px-4 flex flex-row flex-wrap', fields: [
          {field: 'area', label: 'Area', type: 'text', related: 'cardable', classes: 'grid grid-cols-8 p-1 pl-4', labelClasses: 'col-span-2 italic font-bold pr-3', valueClasses: 'col-span-6'},
        ]}
      ]
    }
  }
}